const MODEL = 'model'
const ARCHITECTURE = 'architecture'
const BRANDS = 'brands'
const FORMFACTORS = 'formFactors'
const FULLVERLIST = 'fullVersionList'
const PLATFORM = 'platform'
const PLATFORMVER = 'platformVersion'
const BITNESS = 'bitness'
const MOBILE = 'mobile'
const CH_ALL_VALUES = [
  BRANDS,
  FULLVERLIST,
  MOBILE,
  MODEL,
  PLATFORM,
  PLATFORMVER,
  ARCHITECTURE,
  FORMFACTORS,
  BITNESS,
]

const NAVIGATOR_UA_DATA =
  // eslint-disable-next-line compat/compat
  'userAgentData' in window.navigator && window.navigator.userAgentData

// eslint-disable-next-line import/no-mutable-exports
export let DEVICE_MODEL_FROM_NAVIGATOR: string | undefined

if (NAVIGATOR_UA_DATA) {
  NAVIGATOR_UA_DATA.getHighEntropyValues?.(CH_ALL_VALUES).then(res => {
    DEVICE_MODEL_FROM_NAVIGATOR = res.model
  })
}
